import React from 'react';
import styles from './MyTipsTipBox.module.scss';
import SVG from 'react-inlinesvg';
import boltIcon from '../../assets/icons/tips/bolt.svg';
import classnames from 'classnames';
//Interfaces
import { OddsFormat } from '../TipPublish/interfaces/utils';
import {
  MatchFromBE,
  UnlockedMatchForecast,
  UnlockedTipData,
} from '../../store/tips/reducer';

//Components
import { Confidence } from '../Shops/Tip/components/TipBox/Bottom/Confidence';
import { TipValueWithLabel } from '../Shops/Tip/components/TipValueWithLabel/TipValueWithLabel';
import { MyTipsMatchForecastInfo } from './MyTipsMatchForecastInfo';

//Translations
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';

interface MyTipsTipBoxProps {
  tip: UnlockedTipData;
  oddsFormat: OddsFormat;
  allMatches: MatchFromBE[];
  selectBet?: (tip: UnlockedTipData) => void;
}

export const MyTipsTipBox: React.FC<MyTipsTipBoxProps> = ({
  tip,
  oddsFormat,
  allMatches,
  selectBet,
}) => {
  const { t } = useTranslation();
  const cx = classnames.bind(styles);

  return (
    <div className={cx(styles.container, styles[tip.price_type])} key={tip.id}>
      <div className={styles.header}>
        <SVG className={styles.icon} src={boltIcon} />
        <span className={styles.text}>
          {tr(t, tip.price_type).toUpperCase()}
        </span>
      </div>
      <div className={styles.border}>
        <div className={styles.innerTopBox}>
          <div className={styles.unlocked}>
            {tip.match_forecasts.map((forecast: UnlockedMatchForecast) => (
              <MyTipsMatchForecastInfo
                tip={tip}
                key={forecast.id}
                forecast={forecast}
                match={allMatches.find(
                  (match) => match.id === forecast.match_id,
                )}
              />
            ))}
          </div>
        </div>
        <div className={styles.innerBottomBox}>
          <Confidence confidence={tip.confidence} stake={tip.stake} />

          <TipValueWithLabel label={tr(t, 'odd')}>
            {/* @ts-ignore */}
            {tip.formatted_odds[oddsFormat.toLowerCase()]}
          </TipValueWithLabel>
          <div className={styles.bookieTag}>
            <div className={styles.bookieTagInner}>
              <label>
                {tr(t, 'bet_done_at')} <span>{tip.bookie}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.action}>
        {selectBet && (
          <button
            onClick={() => {
              selectBet(tip);
            }}
            className={styles.actionBtn}
          >
            {tr(t, 'finalize-tip')}
          </button>
        )}
      </div>
    </div>
  );
};
